import React from "react";
import CgIcon from "../common/CgIcon";

/**
 * The board names its icons by what the row is about rather than by glyph, so
 * the data files stay free of JSX and a row's icon can be chosen in the same
 * place as its label. The drawings come from the mockup's own set - see CgIcon.
 */
const NAMES = {
  orders: "forms",
  rupee: "rupee2",
  undo: "undo",
  package: "package",
  cart: "cart",
  stock: "stock",
  clock: "clock",
  partner: "partner",
  /* The reports draw from their own set - a register is a stack of coins or a
     ruled book, not the rupee mark and the trolley the queues use. */
  coins: "coins",
  ledger: "ledger",
  layers: "services",
  storefront: "storefront",
  percent: "percent",
};

export const queueIcon = (name, props = {}) => (
  <CgIcon name={NAMES[name] || NAMES.orders} size={17} stroke={2} {...props} />
);

export default queueIcon;
